import { StyleSheet, View, Platform } from "react-native";
import React, { useState, useEffect } from "react";
import { colors } from "../../styles/GlobalStyle";
import DimensionsHook from "../../hooks/DimensionsHook";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Spinner from "../Spinner";
import { setUserActivity } from "../../redux/Actions";
import WebView from "react-native-webview";
import { H6, Txt } from "../TextsComponents";
import { LislUp } from "../../assets/svg/Logo";
import { useTranslation } from "react-i18next";

const VideoWorkshop = ({ data, setIsOpenGreenModal, navigation }) => {
  const dispatch = useDispatch();
  const { isBigScreen, isTablet, isDesktop } = DimensionsHook();
  const [url, setUrl] = useState("");
  const userActivity = useSelector((state) => state.userActivity);
  const { company } = useSelector((state) => state.userData);

  const { t } = useTranslation();
  const [finished, setFinished] = useState(
    userActivity.current_finished_workshops.includes(data.workshop_code)
  );

  const finishedHandler = async () => {
    setFinished(true);
    const TOKEN = await AsyncStorage.getItem("access_token");
    axios
      .post(process.env.FINISHED_WORKSHOPS, {
        access_token: TOKEN,
        workshop_code: data.workshop_code,
        company,
      })
      .then((res) => {
        dispatch(setUserActivity());
        console.log("added to finished");
      });
  };
  // set workshop base link
  const setBaseLink = () => {
    const l = data.link;
    const baseUrl = l.replace("playlist.m3u8", "");
    //+ "?preload=true";
    setUrl(baseUrl);
  };

  useEffect(() => {
    setBaseLink();
  }, []);

  if (url == "") {
    return (
      <View style={styles.loaderContainer}>
        <Spinner size="large" />
      </View>
    );
  }

  const onTimeUpdateHandler = (e) => {
    const { duration, currentTime } = e.target;

    // mark as finished if current time > 0.8 of duration and not marked before as finished
    if (currentTime / duration > 0.8 && !finished) {
      finishedHandler();
    }
  };
  const onEndedHandler = () => setIsOpenGreenModal(true);

  if (Platform.OS == "web") {
    return (
      <View
        style={{
          width: "100%",
          alignSelf: "center",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: isBigScreen
              ? 1000
              : isDesktop
                ? 700
                : isTablet
                  ? "90%"
                  : "100%",
            aspectRatio: 16 / 9,
          }}
        >
          <video
            src={url + "play_480p.mp4"}
            autoPlay={true}
            poster={url + "thumbnail.jpg"}
            preload="true"
            crossOrigin="anonymous"
            onEnded={onEndedHandler}
            onTimeUpdate={onTimeUpdateHandler}
            controls
            controlsList="nodownload noremoteplayback"
            style={{
              width: "100%",
              aspectRatio: 16 / 9,
              backgroundColor: "#000000",
            }}
          >
            {data.srt.map((srt, i) => {
              return (
                <track
                  default={i == 0 ? true : false}
                  key={srt.value}
                  kind="captions"
                  label={srt.label}
                  src={url + `captions/${srt.value.toUpperCase()}.vtt`}
                  srcLang={srt.value.toLowerCase()}
                ></track>
              );
            })}
          </video>
          <View
            style={{
              width: isBigScreen
                ? 1000
                : isDesktop
                  ? 700
                  : isTablet
                    ? "90%"
                    : "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#00000095",
              padding: 10,
              position: "absolute",
              top: 0,
            }}
          >
            <View style={{ width: 50, height: 50 }}>
              <LislUp color="#f5f5f4" />
            </View>

            <H6 style={{ fontSize: 16 }} color="#fff">
              {data.title}
            </H6>

            <View></View>
          </View>
        </View>
      </View>
    );
  }

  return (
    <View style={{ flex: 1, color: colors.beige }}>
      <WebView
        onMessage={(event) => {
          const data = event.nativeEvent.data;
          if (data == "ended") {
            setIsOpenGreenModal(true);
          } else {
            const d = data.split("-");
            const duration = d[0];
            const current = d[1];
            // if not finished before and watched more than 80%

            if (current / duration > 0.8 && !finished) {
              finishedHandler();
            }
          }
        }}
        containerStyle={{
          margin: 0,
          padding: 0,
        }}
        allowsFullscreenVideo={true}
        scalesPageToFit={false}
        setBuiltInZoomControls={false}
        useWebView2={true}
        source={{
          html: `
          <head>
          <link href="http://vjs.zencdn.net/6.4.0/video-js.css" rel="stylesheet">
        

          </head>
          <body style="margin: 0 !important;padding: 0 !important;">
          <div style="margin:0px; padding:0px; width:100%; height:100%; display:flex; align-items:center; justify-content:center; background-color:#FBF6F3; ">
            <div style=" overflow:hidden;  margin:0 ; padding:0 ;  width:100%; ">
            <video
            id="my-player"
            class="video-js vjs-big-play-centered vjs-fill "
            style="background-color:transparent;"
            preload="true"
            ontimeupdate="onTimeUpdate(this)"
            onended="onEnded()"
            poster="${url + "thumbnail.jpg"}"
            crossorigin="anonymous"
            src="${url + "playlist.m3u8"}"
            controls
            allowfullscreen
            controlsList="nodownload"
            width="100%"
            
          >
          ${data.srt.map(
            (srt, i) => `"<track
          key="${srt.value}"
          kind="captions"
          label="${srt.label}"
          src="${url + `captions/${srt.value.toUpperCase()}.vtt`}"
          srcLang="${srt.value.toLowerCase()}"
          default=${i == 0 ? "true" : "false"}
        ></track>"`
          )}
         
          </video>
           
          
          </div>
          </body>
          <script src="http://vjs.zencdn.net/6.4.0/video.js"></script>
          <script>
          
          function onEnded() {
                window.ReactNativeWebView.postMessage("ended!")
          }
          function onTimeUpdate(e) {
            window.ReactNativeWebView.postMessage(e.duration + "-" + e.currentTime)
          }
          </script>
          `,
        }}
      />
    </View>
  );
};

export default VideoWorkshop;

const styles = StyleSheet.create({
  loaderContainer: { flex: 1, alignItems: "center", justifyContent: "center" },
  container: {
    flex: 1,
    alignSelf: "center",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  videoContainer: {
    elevation: 15,
    marginTop: -15,
    backgroundColor: colors.blue3,
    cursor: "pointer",
  },
  header: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});
